import React from 'react';
import { FaQuoteLeft, FaEnvelope, FaPhone, FaCalendarAlt, FaAward } from 'react-icons/fa';

const PrincipalMessage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50/30">
      <div className="bg-gradient-to-r from-blue-700 to-indigo-700 py-20 text-center text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Principal's Message</h1>
        <div className="w-20 h-1 bg-yellow-400 mx-auto rounded-full mb-4"></div>
        <p className="text-lg max-w-2xl mx-auto">Words of wisdom and guidance from our respected Principal</p>
      </div>

      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="grid md:grid-cols-3 gap-6 p-8">
              <div className="text-center">
                <img src="Principal.png" alt="Principal" className="w-40 h-40 rounded-full object-cover mx-auto border-4 border-blue-200 shadow-lg" />
                <h3 className="text-xl font-bold text-gray-800 mt-4"> DR. VIDYASAGAR UPADHYAY</h3>
                <p className="text-blue-600 text-sm">Principal</p>
                <p className="text-gray-500 text-xs mt-1">M.A. PHD</p>
                <div className="flex justify-center gap-3 mt-3">
                  <FaEnvelope className="text-gray-400 hover:text-blue-600 cursor-pointer" />
                  <FaPhone className="text-gray-400 hover:text-blue-600 cursor-pointer" />
                </div>
              </div>
              <div className="md:col-span-2">
                <FaQuoteLeft className="text-4xl text-blue-200 mb-4" />
                <div className="space-y-4 text-gray-600 leading-relaxed">
                  <p>Dear Students, Parents, and Well-wishers,</p>
                  <p>
                    It is my privilege to welcome you to R.D.S.Snatkottar Mahavidyalaya, an institution that has 
                    been dedicated to the pursuit of knowledge and excellence for over five decades. Education is 
                    not merely about acquiring degrees; it is about building character, nurturing talents, and 
                    preparing for life's challenges.
                  </p>
                  <p>
                    At our college, we believe in holistic education that combines academic rigor with co-curricular 
                    and extracurricular activities. Our dedicated faculty members are committed to providing the 
                    best learning experience, fostering critical thinking, and encouraging innovation.
                  </p>
                  <p>
                    I invite you to be part of our vibrant community where we don't just teach; we inspire, we mentor, 
                    and we shape future leaders. Together, let's embark on a journey of discovery, growth, and success.
                  </p>
                  <p className="font-semibold mt-4">
                    With warm regards,<br />
                    <span className="text-blue-600">DR. VIDYASAGAR UPADHYAY</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 border-t">
              <div className="flex flex-wrap justify-center gap-6">
                <div className="flex items-center gap-2"><FaCalendarAlt className="text-blue-600" /><span className="text-sm">Tenure: 2018 - Present</span></div>
                <div className="flex items-center gap-2"><FaAward className="text-yellow-500" /><span className="text-sm">Best Principal Award 2022</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrincipalMessage;